import React, { useState, useRef, useEffect } from "react";

const AdditionalInfoIcon1 = () => {
  const divRef = useRef(null);

  const [strokeColor, setStrokeColor] = useState("#B4C0C8");

  const handleClick = () => {
    setStrokeColor("#1D4469");
  };

  const handleOutsideClick = (event) => {
    if (divRef.current && !divRef.current.contains(event.target)) {
      setStrokeColor("#B4C0C8");
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  return (
    <div ref={divRef}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="34"
        height="34"
        viewBox="0 0 34 34"
        fill="none"
        onClick={handleClick}
      >
        <rect x="0.5" y="0.5" width="33" height="33" rx="6.5" stroke={strokeColor} />
        <path
          d="M13.875 16.8125C13.875 17.1577 14.1548 17.4375 14.5 17.4375H16.375V19.3125C16.375 19.6577 16.6548 19.9375 17 19.9375C17.3452 19.9375 17.625 19.6577 17.625 19.3125V17.4375H19.5C19.8452 17.4375 20.125 17.1577 20.125 16.8125C20.125 16.4673 19.8452 16.1875 19.5 16.1875H17.625V14.3125C17.625 13.9673 17.3452 13.6875 17 13.6875C16.6548 13.6875 16.375 13.9673 16.375 14.3125V16.1875H14.5C14.1548 16.1875 13.875 16.4673 13.875 16.8125Z"
          fill={strokeColor}
        />
        <path
          d="M14.0127 10.7437L14.8211 10.4089C15.14 10.2767 15.2914 9.91116 15.1593 9.59225C15.0272 9.27334 14.6616 9.12181 14.3427 9.25403L13.5343 9.58891C13.2154 9.72103 13.0639 10.0866 13.1961 10.4055C13.3278 10.7234 13.6927 10.8762 14.0127 10.7437Z"
          fill={strokeColor}
        />
        <path
          d="M17 8.8125C16.6548 8.8125 16.375 9.09231 16.375 9.4375C16.375 9.78269 16.6548 10.0625 17 10.0625C20.7306 10.0625 23.75 13.0815 23.75 16.8125C23.75 20.5431 20.731 23.5625 17 23.5625C13.2694 23.5625 10.25 20.5435 10.25 16.8125C10.25 16.4673 9.97019 16.1875 9.625 16.1875C9.27981 16.1875 9 16.4673 9 16.8125C9 21.2338 12.578 24.8125 17 24.8125C21.4213 24.8125 25 21.2345 25 16.8125C25 12.3912 21.422 8.8125 17 8.8125Z"
          fill={strokeColor}
        />
        <path
          d="M11.9177 12.3489L12.5364 11.7302C12.7805 11.4861 12.7805 11.0903 12.5364 10.8463C12.2923 10.6022 11.8966 10.6022 11.6525 10.8463L11.0338 11.465C10.7897 11.7091 10.7897 12.1048 11.0338 12.3489C11.2778 12.5929 11.6736 12.593 11.9177 12.3489Z"
          fill={strokeColor}
        />
        <path
          d="M9.77975 14.9718C10.0993 15.1042 10.4646 14.9518 10.5964 14.6336L10.9312 13.8252C11.0634 13.5063 10.9119 13.1407 10.593 13.0086C10.2741 12.8765 9.90853 13.0279 9.77641 13.3468L9.44153 14.1552C9.30941 14.4741 9.46087 14.8397 9.77975 14.9718Z"
          fill={strokeColor}
        />
      </svg>
    </div>
  );
};

export default AdditionalInfoIcon1;
